<template>
  <div :class="$style.wrapper">
    <div :class="$style.content">
      <h1>Привет!</h1>
      <p>
        Перед тобой упрощённый вариант теста Тьюринга. <br>
        Определи, кто был собеседником в каждом диалоге и <br>
        перенеси карточку в соответствующую часть экрана. <br>
        За правильные ответы начисляются баллы. <br>
        Будь внимательнее, для каждого диалога <br>
        есть одна попытка. Удачи!
      </p>
      <v-btn fluid class="mt-3" @click="() => $emit('next')">Начать</v-btn>
    </div>
    <div :class="$style.bubblesWrapper">
      <div :class="$style.bubbles">
        <div v-for="index in 100" :key="index">
          <Bubble :color="randomColor()" :pin="randomPin()" animated />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Bubble from '@/components/@ui/Bubble/Bubble'

export default {
  name: 'Start',
  components: { Bubble },
  methods: {
    randomColor() {
      const colors = ['pink', 'yellow', 'orange', 'lightGrey', 'grey', 'teal', 'green', 'brown', 'peach']
      return colors[Math.floor(Math.random() * colors.length)]
    },
    randomPin() {
      return Math.random() > 0.5
    },
  },
}
</script>
<style lang="scss" module>
.wrapper {
  width: 100%;
  min-height: 100%;
  padding: 2rem 6rem;
  position: relative;

  h1 + p {
    margin-top: 3.8rem;
  }
}

.content {
  position: relative;
  z-index: 10;
}

@keyframes bubbles-move {
  from {
    transform: rotate(-45deg) translateX(-300%);
  }
  to {
    transform: rotate(-45deg) translateX(0);
  }
}

.bubblesWrapper {
  position: fixed;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.bubbles {
  width: 100%;
  height: 100%;
  pointer-events: none;
  transform: rotate(-45deg);
  animation: bubbles-move 120s linear infinite;
  margin-top: 40rem;

  & > div {
    position: absolute;
    transform: rotate(45deg);

    &:nth-child(3n + 1) {
      bottom: 0;
    }
    &:nth-child(3n + 2) {
      bottom: 30rem;
    }
    &:nth-child(3n + 3) {
      bottom: 60rem;
    }
    @for $i from 1 through 100 {
      &:nth-child(#{$i}) {
        //right: round($i / 3) * 20% + $i * 3%;
        left: round($i / 3) * 30rem;
      }
    }
  }
}

</style>
